import { normalize } from "normalizr";
import { RECEIVE_DEVICES, REQUEST_DEVICES } from "./types";
import { deviceSchema } from "../../schemas";
import * as ApiConstants from "../../helpers/api";
import { requestWithAuth } from "../../utils/request";
const DEVICES_ENDPOINT = `${ApiConstants.getApiUrl()}/devices`;

function requestDevices() {
    return { type: REQUEST_DEVICES };
}

export function fetchDevices() {
    return dispatch => {
        dispatch(requestDevices());
        return requestWithAuth(dispatch, http => http.get(DEVICES_ENDPOINT))
            .then(({ data }) => {
                const { devices } = data;
                const { entities, result } = normalize(devices, [deviceSchema]);
                dispatch({
                    type: RECEIVE_DEVICES,
                    recievedAt: Date.now(),
                    entities,
                    devices: result
                });
            })
            .catch(err => console.error(err));
    };
}



// WEBPACK FOOTER //
// ./src/modules/devices/actions.js